import React from 'react';

class FallbackImage extends React.Component {
  state = {failed: false};

  handleError = () => {
    this.setState({failed: true});
  };

  render() {
    const {src, fallbackSrc, ...rest} = this.props;

    return (
      <img
        onError={this.handleError}
        src={this.state.failed ? fallbackSrc : src}
        {...rest}
      />
    );
  }
}

export default FallbackImage;
